// extracted by mini-css-extract-plugin
export default {"Octicon":"BypassAvatar-module__Octicon--d2fg7"};